import React, {useEffect, useState} from "react";
import './App.css';
import Header from './components/Header/Header'
import Menu from "./components/Menu/Menu";
import Content from "./components/Content/Content";
import Footer from "./components/Footer/Footer";
import {Redirect, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import NotExistPage from "./pages/NotExistPage/NotExistPage";
import { ReactNotifications } from "react-notifications-component";
import {compose} from "redux";
import {WithAuthRedirect} from "./hoc/WithAuthRedirect";
import {useDispatch} from "react-redux";
import {readFromStorage} from "./api/storageApi";
import ProductContainer from "./pages/Products/ProductContainer";
import BlogContainer from "./pages/Blogs/BlogContainer";
import ProductTypesContainer from "./pages/ProductTypes/ProductTypesContainer";
import SalesContainer from "./pages/Sales/SalesContainer";
import UsersContainer from "./pages/Users/UsersContainer";
import ProfileContainer from "./pages/Profile/ProfileContainer";
//'RECEPTION' 'MANAGER' 'ADMIN'


const AuthenticatedView=React.memo(({logOutMe,username,...rest})=>{
    const dispatch=useDispatch()
    const localToken=readFromStorage("roles");
    let  userRole=  localToken ? localToken :  'ADMIN';
// console.log(userRole)
    useEffect(()=>{
        // dispatch(getAppUsersTh(0,100))
        // dispatch(getGroupsTh(0,100))
    },[])
    debugger
    return(
        <div className="wrapper">
            <ReactNotifications/>
            <Header logOutMe={logOutMe} />
            <Menu username={username} userRole={userRole}/>
            <Switch>
                {userRole ==='ADMIN'
                    && <Route path='/Home' render={() => <Content/>}/>}
                {userRole==='ADMIN' &&<Route path='/products' render={() => <ProductContainer {...rest}/>}/>}
                {userRole==='ADMIN' &&<Route path='/blogs' render={() => <BlogContainer {...rest}/>}/>}
                {userRole==='ADMIN' &&<Route path='/productType' render={() => <ProductTypesContainer/>}/>}
                {userRole==='ADMIN' &&<Route path='/sales' render={() => <SalesContainer/>}/>}
                {userRole==='ADMIN' &&<Route path='/users' render={() => <UsersContainer/>}/>}
                <Route path='/profile' render={() => <ProfileContainer/>}/>
                <Route exact path='/'><Redirect to={"/Home"}/> </Route>
                <Route path='*' render={() => <NotExistPage/>}/>
            </Switch>
            <Footer/>
        </div>
    )
})
export default compose(
    WithAuthRedirect,
)(AuthenticatedView);
